import React from 'react';
import HeaderSection from '../shared/HeaderSection';
import HeroBannerSection from '../shared/HeroBannerSection';
import {
  DOM_HEADER_SECTION,
} from '../../../../lib/constants';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import {
  getHeroBannersProps,
  getHeroSectionBannerLifestyleBannerProps,
} from '../../../../lib/helpers/getHeroBannerSectionProps.helpers';
import SlideShow from '../Carousel/SlideShow';

const renderHeaderSectionComponent = ({
  headerSectionData,
  locale,
  pageStateModifiers,
}) => {
  switch (headerSectionData.__typename) {
    case 'headerSection': {
      const desktopPage = (
        <div>
          <HeaderSection
            locale={locale}
            headerSectionData={headerSectionData}
            parentId={DOM_HEADER_SECTION}
            pageStateModifiers={pageStateModifiers} />
        </div>
      );

      const mobilePage = (
        <div>
          <HeaderSection
            locale={locale}
            headerSectionData={headerSectionData}
            parentId={DOM_HEADER_SECTION}
            pageStateModifiers={pageStateModifiers}
            isMobile />
        </div>
      );

      return (
        <MediaQueryHelper
          desktopChildren={desktopPage}
          mobileChildren={mobilePage}
        />
      );
    }

    case 'layoutLifestyleBanner': {
      if (headerSectionData.contentType === 'layoutHeroBanner') {
        const bannerLayout = headerSectionData;
        const {
          textOverlay: bannerTitle,
          heroImageUrl,
          verticalHeroImageUrl,
          subtitle,
          heroImageAltText,
          backgroundColor,
          showDatesLabel = false,
          hexColorForTextOverlay,
        } = bannerLayout;

        const {
          labelText,
          buttons,
        } = getHeroSectionBannerLifestyleBannerProps(bannerLayout, locale);

        return (
          <HeroBannerSection
            heroImageUrl={heroImageUrl}
            portraitTabletHeroImageUrl={verticalHeroImageUrl}
            heroImageAltText={heroImageAltText}
            heading={bannerTitle}
            subheading={subtitle}
            labelText={showDatesLabel && labelText}
            buttons={buttons}
            backgroundColor={backgroundColor}
            textColor={hexColorForTextOverlay}
            classNames="is-standalone-layout"
          />
        );
      }
      return null;
    }

    case 'layoutCarouselContainer': {
      const renderItems = getHeroBannersProps(headerSectionData.items, locale);

      if (!renderItems.length) {
        return null;
      }

      const outerBgColor = headerSectionData.backgroundColor;

      // TODO: Add logic to render differen item types, when added
      if (renderItems.length === 1) {
        return (
          <HeroBannerSection
            {...renderItems[0]}
            hasMultipleBg={outerBgColor !== renderItems[0].backgroundColor}
            classNames="is-standalone-layout"
          />
        );
      }

      return (
        <SlideShow
          contorlsTheme={headerSectionData.controlsTheme}
          controlsTopMargin={headerSectionData.controlsTopMargin}
        >
          {renderItems.map((item) => (
            <HeroBannerSection
              {...item}
              hasMultipleBg={outerBgColor !== item.backgroundColor}
            />
          ))}
        </SlideShow>
      );
    }

    default:
      return null;
  }
};

const GreetingSectionAnonUser = (props) => {
  const {
    headerSectionData = {},
    locale,
    pageStateModifiers,
  } = props;

  return renderHeaderSectionComponent({
    headerSectionData,
    locale,
    pageStateModifiers,
  });
};

export default GreetingSectionAnonUser;
